module.exports = __webpack_public_path__ + "static/media/dp-favicon.ac579acc.ico";